/***
 *
 *   PROFILE
 *   Update the user profile or close the account
 *
 **********/

import axios from "axios";
import {
  AccountNav,
  Animate,
  AuthContext,
  Form,
  Icon,
  ViewContext,
  useAPI,
} from "components/lib";
import {Fragment, useContext, useEffect, useState} from "react";
import agencyDefaultAvatar from "./images/agencyDefaultAvatar.png";
import loader from "./images/loading.gif";

export function Profile(props) {
  // context
  const authContext = useContext(AuthContext);
  const viewContext = useContext(ViewContext);
  const [loading, setLoading] = useState(true);
  const [changePicture, setChangePicture] = useState(false);
  const [avatar, setAvatar] = useState();

  // fetch
  const user = useAPI("/api/user");

  useEffect(() => {
    axios
      .get("/api/user")
      .then((r) => {
        setLoading(false);
        setAvatar(r.data.data.avatar);
      })
      .catch((fileErr) => {
        setLoading(false);

        viewContext.notification.show(
          "Failed on get user avatar.",
          "error",
          true,
          "toast",
          "x-circle"
        );
      });
  }, []);

  function click() {
    const avatar_file = document.getElementById("avatar_file");

    if (avatar_file) {
      avatar_file.click();
    }
  }

  return (
    <Fragment>
      <AccountNav/>
      <Animate>
        <div
          style={{
            width: 400,
            backgroundColor: "white",
            padding: 20,
            borderRadius: 10,
          }}
        >
          <div
            style={{
              width: "100%",
              textAlign: "center",
              marginBottom: 20,
              fontSize: 18,
              fontWeight: 600,
            }}
          >
            Edit your profile
          </div>
          {user?.data && (
            <>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  onMouseEnter={() => {
                    setChangePicture(true);
                  }}
                  style={{
                    width: "120px",
                    height: "120px",
                    borderRadius: 120,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 30,
                    backgroundColor: "black",
                    backgroundPosition: `center`,
                    backgroundSize: avatar ? `cover` : `60%`,
                    backgroundRepeat: "no-repeat",
                    backgroundImage: `url(${
                      avatar ? `${avatar}` : `${agencyDefaultAvatar}`
                    })`,
                  }}
                />
                <div
                  onMouseLeave={() => {
                    setChangePicture(false);
                  }}
                  style={{
                    width: "120px",
                    height: "120px",
                    borderRadius: 120,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    position: "absolute",
                    marginBottom: 30,
                    display: changePicture ? "flex" : "none",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => click()}
                >
                  <Icon image="camera" color="#fff" size={25}/>
                  <input
                    id="avatar_file"
                    type="file"
                    style={{display: "none"}}
                    onChange={async (e) => {
                      setLoading(true);

                      const file =
                        document.getElementById("avatar_file").files[0];

                      const form_data = new FormData();

                      if (file) {
                        form_data.append("file", file);
                      }

                      await axios
                        .post(`/api/user/avatar`, form_data, {
                          headers: {
                            "Content-Type": "multipart/form-data",
                          },
                        })
                        .then((r) => {
                          setLoading(false);

                          console.log(r);

                          setAvatar(r.data.link);
                        })
                        .catch((fileErr) => {
                          setLoading(false);

                          viewContext.notification.show(
                            "Failed on upload file to server.",
                            "error",
                            true,
                            "toast",
                            "x-circle"
                          );
                        });
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "120px",
                    height: "120px",
                    borderRadius: 120,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    position: "absolute",
                    marginBottom: 30,
                    display: loading ? "flex" : "none",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  <img src={loader} alt="loading" width={30} height={30}/>
                </div>
              </div>
              <Form
                buttonText="Save"
                url="/api/user"
                method="PATCH"
                inputs={{
                  firstName: {
                    label: "First Name",
                    type: "text",
                    required: true,
                    value: user.data.name.split(" ")[0]?.trim() ?? "",
                    disabled: true,
                    errorMessage: "Please enter your first name",
                  },
                  lastName: {
                    label: "Last Name",
                    type: "text",
                    required: true,
                    value: user.data.name.split(" ")[1]?.trim() ?? "",
                    errorMessage: "Please enter your last name",
                    disabled: true,
                  },
                  email: {
                    label: "Email address",
                    type: "email",
                    required: true,
                    value: user.data.email,
                    disabled: true,
                    omitOnSubmit: true,
                    errorMessage: "Please enter your email address",
                  },
                }}
                callback={(res) => {
                  // update the account name
                  if (authContext.user?.accounts?.length > 0) {
                    const accounts = [...authContext.user.accounts];
                    accounts[
                      accounts.findIndex(
                        (x) => x.id === authContext.user.account_id
                      )
                      ].name = res.data.data.account_name;
                    authContext.update({accounts: accounts});
                  }

                  // update the user name
                  authContext.update({name: res.data.data.name});
                }}
              />
            </>
          )}
        </div>
      </Animate>
    </Fragment>
  );
}
